export default "__VITE_ASSET__BpOVjeBk__"